import { render, staticRenderFns } from "./CertificatePreview.vue?vue&type=template&id=f0d0dea4&scoped=true&"
import script from "./CertificatePreview.vue?vue&type=script&lang=js&"
export * from "./CertificatePreview.vue?vue&type=script&lang=js&"
import style0 from "./CertificatePreview.vue?vue&type=style&index=0&id=f0d0dea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d0dea4",
  null
  
)

export default component.exports